let notes: string[] = [];
let active = false;

export async function callWithNote<T>(fn: () => Promise<T>): Promise<[string[], T]> {
    active = true;
    const result = await fn();
    active = false;
    const noteCopy = [...notes];
    notes = [];
    return [noteCopy, result];
}

export const addNoteToCallStack = (note: string) => {
    if (active) {
        notes.push(note);
    }
};
